var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.40413,
    y: 2.40413,
    width: 78.1917,
    height: 78.1917,
    rx: 39.0959,
    stroke: "white",
    strokeWidth: 4.80827
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 39.2524C25.4826 39.2524 24.2524 40.4826 24.2524 42C24.2524 43.5174 25.4826 44.7476 27 44.7476V39.2524ZM57.9428 43.9428C59.0158 42.8698 59.0158 41.1302 57.9428 40.0572L40.4573 22.5717C39.3843 21.4987 37.6447 21.4987 36.5717 22.5717C35.4987 23.6447 35.4987 25.3843 36.5717 26.4573L52.1143 42L36.5717 57.5427C35.4987 58.6157 35.4987 60.3553 36.5717 61.4283C37.6447 62.5013 39.3843 62.5013 40.4573 61.4283L57.9428 43.9428ZM27 44.7476H56V39.2524H27V44.7476Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9fc8f981df53a0f6248945c5e62df318.svg";
export { ForwardRef as ReactComponent };